import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ROLE_HOME } from "@/lib/roles";

/**
 * Sends the authenticated user to their role's default landing page.
 * Used as the handler for "/" once the user is logged in.
 */
export default function RoleRedirect() {
  const { role } = useAuth();
  const target = ROLE_HOME[role] || "/unauthorized";
  return <Navigate to={target} replace />;
}
